import { GetPickupGuideOutput } from '@allocab/allocab-commons-shared-types';
import { FileLinesRegular } from '@allocab/allocab-icons';

import { t } from '../../services/translation/translation';

type Props = {
  dataGuide: GetPickupGuideOutput;
};

export const TripGuideDownloadButton = ({ dataGuide }: Props) => {
  return (
    <div className="p-5">
      <a
        className="flex items-center gap-3 justify-center font-medium text-blue-600 dark:text-blue-500 hover:underline"
        href={`https://allocab.com/${dataGuide.urlSuffix}`}
        target="_blank"
        rel="noreferrer"
      >
        {t('trip-route.guide')}
        <FileLinesRegular height={16} width={16} />
      </a>
    </div>
  );
};
